<ng-container *ngIf="translate$ | async"></ng-container>
<ng-container *ngIf="userAttributes$ | async"></ng-container>
<ng-container *ngIf="mfacheck$ | async"></ng-container>
<ng-container *ngIf="loadingPage$ | async"></ng-container>

<div id="App" [ngClass]="{ 'hide-menu': hideMenu }">
  <ng-container *ngIf="notificationStatus$ | async"></ng-container>
  <scaffold-layout
    [ngClass]="{ 'nb-layout-iframe': iframeService?.isInIframe }"
    [showFrame]="!iframeService?.isInIframe"
    [leftSidebarState]="sideNavState"
  >
    <div
      layout-header
      *ngIf="!hideMenu"
      [ngClass]="{ 'nb-layout-header-hide': iframeService?.isInIframe }"
    >
      <div id="header-bar" *ngIf="!iframeService?.isInIframe">
        <div class="env-notice" *ngIf="env">
          This is a {{ env }} Environment
        </div>
        <div class="scaffold-toolbar">
          <p-button
            tourTarget
            [tourId]="'scaffold-theme-setup,create-integration,create-import'"
            [stepId]="'step-1,step-1,step-1'"
            [tourPosition]="'left,left,left'"
            severity="contrast"
            variant="text"
            class="header-button scaffold-menu-toggle text-3xl pl-3 pr-3 pt-1"
            (click)="leftNavtoggle()"
            aria-label="Toggle Scaffold menu visibility"
            icon="fa fa-bars"
          >
          </p-button>

          <a routerLink="/home" class="school-logo-wrapper">
            <img
              class="school-logo"
              src="school-assets/school_logo.png"
              alt="Navigate to landing page link image"
            /></a>
          <a routerLink="/home" class="school-logo-wrapper-dark">
            <img
              class="school-logo"
              src="school-assets/school_logo_dark.png"
              alt="Navigate to landing page link image"
              *ngIf="!darkLogoError; else fallbackLogo"
              (error)="darkLogoError = true"
            ></a>
          <ng-template #fallbackLogo>
            <img
              class="school-logo"
              src="school-assets/school_logo.png"
              alt="Navigate to landing page link image"
            />
          </ng-template>
          <span class="header-padding"></span>
          <div style="display: flex; gap: 5px; margin-right: 5px">
            <app-scaffold-type
              [selected]="selectedType"
              (changed)="setInstance($event)"
              label="Product:"
            ></app-scaffold-type>

            <div class="notification-button-wrapper" style="position: relative">
              <p-overlayBadge
                [value]="activeNotificationCount"
                severity="warn"
                badgeSize="small"
                *ngIf="activeNotificationCount != 0"
                ><div
                  class="notification-button-container"
                  [class.active-notifications]="activeNotificationCount != 0"
                >
                  <p-button
                    severity="contrast"
                    variant="text"
                    (click)="openNotifications()"
                    icon="fas fa-bell"
                  >
                  </p-button>
                </div>
              </p-overlayBadge>
            </div>
            <div style="display: flex; align-items: center">
              <scaffold-toggle-slide
                *ngIf="displayAutosave"
                [(ngModel)]="itemsService.autosave"
                status="contrast"
                size="small"
                name="autosave"
                ngDefaultControl
                >{{
                  "autosave" | translation | transformText : "capitalize"
                }}</scaffold-toggle-slide
              >
            </div>

            <p-button
              severity="contrast"
              variant="text"
              (click)="toggleTheme()"
              aria-label="Toggle theme"
              [icon]="isDarkMode ? 'fa fa-moon' : 'fa fa-sun-bright'"
            >
            </p-button>
          </div>
          <div>
            <p-menu
              #personMenu
              [model]="personalMenu"
              [popup]="true"
              [appendTo]="'body'"
            ></p-menu>
            <p-button
              variant="text"
              severity="contrast"
              (click)="personMenu.toggle($event)"
            >
              <p-avatar
                *ngIf="userInfo"
                [image]="userInfo.picture"
                shape="circle"
                size="large"
              ></p-avatar>
              <span> {{ userInfo?.given_name || userInfo?.first_name }} </span>
              <i class="fas fa-caret-down"></i>
            </p-button>
          </div>
        </div>
      </div>
    </div>

    <div layout-sidebar-left tag="main-sidebar">
      <div
        class="main-sidebar-loading-container"
        *ngIf="globalLeftMenuItems.length < 1"
      >
        <i class="fas fa-spinner fa-spin"></i>
      </div>

      <div class="main-sidebar-left-menu-items-container">
        <a
          *ngFor="let button of globalLeftMenuItems"
          class="left-menu-button"
          routerLinkActive="left-menu-button-active"
          tabIndex="-1"
          routerLink="{{ button.link }}"
          tourTarget
          [tourId]="button.tourId"
          [stepId]="button.stepId"
          [tourPosition]="button.position"
          (click)="tourService.nextStep(button.tourId, button.stepId)"
        >
          <p-overlayBadge
            badgeSize="small"
            [value]="button.badge() | async"
            severity="warn"
            *ngIf="button.badge && (button.badge() | async)"
            [style]="{ 'margin-right': '20%' }"
          ></p-overlayBadge>
          <div class="left-menu-button-label">
            <div class="text-2xl">
              <i
                [class]="button.icon.pack + ' ' + 'fa-' + button.icon.icon"
              ></i>
            </div>
            <div class="text-xs">
              {{ button.translation_key || button.title | translation }}
            </div>
          </div>
        </a>
      </div>
      <div class="footer-menu">
        <div *ngFor="let menuItem of footerMenu">
          <ng-container [ngSwitch]="menuItem.type">
            <div *ngSwitchCase="'link'">
              <a class="footer-menu-item" [routerLink]="menuItem.link">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{
                  menuItem.translation_key || menuItem.title | translation
                }}</span>
              </a>
            </div>
            <div *ngSwitchCase="'modal'">
              <a
                class="footer-menu-item"
                (click)="openFooterModal(menuItem.modal)"
              >
                <i [ngClass]="menuItem.icon"></i>
                <span>{{
                  menuItem.translation_key || menuItem.title | translation
                }}</span>
              </a>
            </div>
            <div *ngSwitchCase="'url'">
              <a class="footer-menu-item" [href]="menuItem.url" target="_blank">
                <i [ngClass]="menuItem.icon"></i>
                <span>{{
                  menuItem.translation_key || menuItem.title | translation
                }}</span>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="scaffold-column">
      <div>
        <scaffold-notification-bar
          *ngFor="
            let notification of notificationService.barNotifications() | async
          "
          [notification]="notification"
        ></scaffold-notification-bar>
      </div>
      <div class="app-body-content" (click)="closeProperties($event)">
        <div
          *ngIf="showLoadingContentOverlay"
          class="app-body-content-loading-ovelay"
        >
          <app-overlay
            [overlayStyles]="{ opacity: 0.95, position: fixed }"
          ></app-overlay>
        </div>
        <div><router-outlet></router-outlet></div>
      </div>

      <div #modalViewRef></div>
    </div>
  </scaffold-layout>
</div>
